<script>
  import {fadeScale} from "../transition/fadeScale";
  import _ from 'lodash';
  import {MenuItem} from "../constants";

  export let showAbove = false;
  export let limitRight = false;
  export let limitLeft = false;

  // [{icon, name, action, color = 'black'}, MenuItem.divider, ...]
  export let items = [];

  let visible = false;
  let container;
  let dropdown;

  let dropdownPosition = {
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto'
  };

  let dropdownArrowPosition = {
    left: 'auto',
    top: 'auto',
    bottom: 'auto'
  };

  let transformOrigin = {
    x: 0.5,
    y: 0
  };

  const toggleDropdown = async () => {
    if (!visible) {
      // to be shown - set dropdown position

      const containerRect = container.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();

      dropdownPosition = {...dropdownPosition};
      dropdownArrowPosition = {
        ...dropdownArrowPosition,
        left: (containerRect.left + containerRect.width / 2 - 4) + 'px'
      };
      transformOrigin = {...transformOrigin};

      if (limitRight) {
        dropdownPosition.right = (window.innerWidth - (containerRect.left + containerRect.width)) + 'px';
      }
      if (limitLeft) {
        dropdownPosition.left = containerRect.left + 'px';
      }

      if (!limitLeft && !limitRight) {
        dropdownPosition.left = (containerRect.left + (containerRect.width / 2) - (dropdownRect.width / 2)) + 'px';
      }

      if ((!limitRight && !limitLeft) || (limitLeft && limitRight)) {
        transformOrigin.x = 0.5;
      } else if (limitLeft) {
        transformOrigin.x = 0;
      } else if (limitRight) {
        transformOrigin.x = 1;
      }

      if (showAbove) {
        dropdownPosition.top = 'auto';
        dropdownPosition.bottom = (window.innerHeight - (containerRect.top + containerRect.height)) + 'px';
        dropdownArrowPosition.top = 'auto';
        dropdownArrowPosition.bottom = (window.innerHeight - (containerRect.top + containerRect.height) - 8) + 'px';
        transformOrigin.y = 1;
      } else {
        dropdownPosition.bottom = 'auto';
        dropdownPosition.top = (containerRect.top + containerRect.height) + 'px';
        dropdownArrowPosition.top = (containerRect.top + containerRect.height - 8) + 'px';
        dropdownArrowPosition.bottom = 'auto';
        transformOrigin.y = 0;
      }
    }
    visible = !visible;
  };


  const onWindowMouseDown = () => {
    if (visible) {
      visible = !visible;
    }
  };
</script>

<svelte:window on:mousedown={onWindowMouseDown}></svelte:window>


<div class="dropdown-container" bind:this={container}>
  <div on:click={toggleDropdown} on:mousedown={e => e.stopPropagation()}>
    <slot name="content">

    </slot>
  </div>

  <div
      class="dropdown"
      class:visible={visible}
      style="{_.map(dropdownPosition, (v, k) => `${k}:${v};`).join('')} transform-origin: {transformOrigin.x * 100}% {transformOrigin.y * 100}%;"
      on:click={() => visible = false}
      on:mousedown={e => e.stopPropagation()}
      bind:this={dropdown}
          transition:fadeScale={{originX: transformOrigin.x, originY: transformOrigin.y, scale: 0.8, duration: 100}}>
    <div
        class="dropdown-inner"
        style="">
        {#each items as item}
            {#if item === MenuItem.divider}
              <div class="divider"></div>
            {:else}
              <row
                  class="clickable menu-item"
                  style="color: {item.color || 'black'}"
                  on:click={item.action}>
                <ion-icon name={item.icon}></ion-icon>
                  {item.name}
              </row>
            {/if}

        {/each}
    </div>
  </div>

  <div
      class="dropdown-arrow"
      class:visible={visible}
      style="{_.map(dropdownArrowPosition, (v, k) => `$   :$   ;`).join('')} transform: rotate({showAbove ? 180 : 0}deg);"
  />
</div>


<style>
  .dropdown-container {
    position: relative;
  }

  .dropdown {
    position: fixed;
    pointer-events: none;
    transform: scale(0.8);
    opacity: 0;
    transition: all .15s;
    background-color: white;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    overflow: hidden;
    z-index: 1;
  }

  .dropdown.visible {
    transform: scale(1);
    opacity: 1;
    pointer-events: auto;
  }

  .dropdown-arrow {
    position: fixed;
    border-bottom: 8px solid white;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    z-index: 1;
    opacity: 0;
    transition: all .15s;
  }

  .dropdown-arrow.visible {
    opacity: 1;
  }

  .menu-item {
    padding: 12px 12px;
    border-bottom: 1px solid #ddd;
  }

  .menu-item ion-icon {
    margin-right: 8px;
  }

  .menu-item:last-child {
    border-bottom: none;
  }

  .divider {
    height: 1px;
    background-color: #ddd;
  }
</style>